import { Label, useUrlParams } from '@localina/core';
import { RestaurantIcon } from '@localina/icons';
import React from 'react';
import { usePublicReservationByToken } from '../../api/queries/reservations';

// The restaurant the request is for, on the left of the top bar. Reads the page's own query, never fetches.
const ReviewRequestRestaurant = () => {
    const [urlParams] = useUrlParams();
    const reservationQuery = usePublicReservationByToken(
        urlParams.get('restaurantId') || '',
        urlParams.get('token') || '',
        { enabled: false },
    );
    const restaurantName = reservationQuery.data?.restaurantName;

    return restaurantName ? (
        <div className="menu review-request-restaurant">
            <span className="review-request-restaurant__tile">
                <RestaurantIcon />
            </span>
            <Label type="text" value={restaurantName} />
        </div>
    ) : null;
};

export default ReviewRequestRestaurant;
